import trimEnd from 'lodash/trimEnd';
import memoizeOne from 'memoize-one';

export const sanitizeQueryString = memoizeOne((queryString) => {
  return trimEnd(
    queryString.replace(/(modal|speakerId|workshopId|userId|startDate)=[^&]+&?/g, ''),
    '&',
  );
});
